/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Box { 
    /**
     * Length of the box long side (mm)
     */
    length?: number;
    /**
     * Width of the box short side (mm)
     */
    width?: number;
    /**
     * Box height (mm)
     */
    height?: number;
    /**
     * Box weight (grams)
     */
    weight?: number;
    /**
     * How close something can be placed to the short sides of the box. It extends the boxes’ length (mm)
     */
    lengthMargin?: number;
    /**
     * How close something can be placed to the long sides of the box. It extends the boxes’ width (mm)
     */
    widthMargin?: number;
    /**
     * Where is the label placed on the box. Deprecated! Replaced by a program setting that should be configured in relation with box orientation on conveyor and conveyor configuration.
     */
    labelPlacement?: Box.LabelPlacementEnum;
    /**
     * Allow user to specify box dimensions and weights that violate robot limitations.
     */
    ignoreBoxLimitations?: boolean;
}
export namespace Box {
    export type LabelPlacementEnum = 'SHORT_SIDE' | 'LONG_SIDE' | 'CORNER';
    export const LabelPlacementEnum = {
        SHORT_SIDE: 'SHORT_SIDE' as LabelPlacementEnum,
        LONG_SIDE: 'LONG_SIDE' as LabelPlacementEnum,
        CORNER: 'CORNER' as LabelPlacementEnum
    };
}


